import { useMemo, useState } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { CalendarIcon } from '@zep-us/zus-icons';
import { format, isValid, parseISO } from 'date-fns';
import { useLocale } from '@/hooks';
import { Calendar, Popover, PopoverContent, PopoverTrigger } from '@/ui';
import { getDateFnsLocale } from '@/ui/components/calendar-locale-utils';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
interface QuoteDateFieldProps {
  label: string;
  /** YYYY-MM-DD */
  value: string;
  onChange: (value: string) => void;
}

/** 사용 시작일 — 앱 공통 DatePickerPopover 패턴을 전체폭 필드로 재구성. */
export function QuoteDateField({
  label,
  value,
  onChange
}: QuoteDateFieldProps) {
  const {
    locale
  } = useLocale();
  const [open, setOpen] = useState(false);
  const selected = useMemo(() => parseISO(value), [value]);
  const minDate = useMemo(() => new Date(), []);
  const display = isValid(selected) ? format(selected, 'yyyy.MM.dd') : '';
  return <div className="flex w-full flex-col gap-3xs" data-sentry-component="QuoteDateField" data-sentry-source-file="QuoteDateField.tsx">
      <span className="text-body-lg-bold text-default">{label}</span>
      <Popover open={open} onOpenChange={setOpen} data-sentry-element="Popover" data-sentry-source-file="QuoteDateField.tsx">
        <PopoverTrigger asChild data-sentry-element="PopoverTrigger" data-sentry-source-file="QuoteDateField.tsx">
          <Button id="quote-start-date" intent="neutral" variant="outlined" rightSlot={<CalendarIcon fill={ICON_COLOR.alternative} size="md" />} className={cn('flex w-full justify-between p-sm text-body-lg-medium text-default hover:bg-default', open && 'ring-2 ring-strong-default')} data-sentry-element="Button" data-sentry-source-file="QuoteDateField.tsx">
            {display}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto overflow-hidden p-0" align="start" data-sentry-element="PopoverContent" data-sentry-source-file="QuoteDateField.tsx">
          <Calendar navLayout="after" mode="single" locale={getDateFnsLocale(locale)} selected={isValid(selected) ? selected : undefined} defaultMonth={isValid(selected) ? selected : minDate} weekStartsOn={0} disabled={{
          before: minDate
        }} showOutsideDays={false} onSelect={date => {
          if (date) {
            onChange(format(date, 'yyyy-MM-dd'));
          }
          setOpen(false);
        }} data-sentry-element="Calendar" data-sentry-source-file="QuoteDateField.tsx" />
        </PopoverContent>
      </Popover>
    </div>;
}